<template>
    <div class="social-account-choice" v-bind:class="{['variant-'+variant]: variant}">
        <div class="flex-content">
            <div class="width-100 relative text-center">
                <svgicon :name="variant" />
            </div>
        </div>
        <div class="checkbox-wrap">
            <Input type="checkbox" width="inline"/>
        </div>
    </div>
</template>
<script>
    import Input from "../../components/Input/Input";

    export default {
        name: 'SocialAccountChoice',
        components: {
            Input
        },
        props: {
            variant: {
                type: String
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./SocialAccountChoice.scss" lang="scss"></style>

